import { Box, Grid, GridBoxList } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Loading from 'modules/core/components/Loading'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import contractVersionsPayrollPolicies from 'modules/contracts/store/collections/contractVersionsPayrollPolicies'
import payrollPolicies from 'modules/payroll_bundle/store/collections/policies'

import PayrollPolicyItem from '../PayrollPolicyItem'

const Content = () => {
  const { loading } = useAsyncData(() => {
    return Promise.all([
      payrollPolicies.fetch(),
      contractVersions.fetch(),
      contractVersionsPayrollPolicies.fetch(),
    ])
  }, [])

  if (loading) return <Loading />

  const payrollPolicyItems = payrollPolicies.models.map((payrollPolicy) => (
    <PayrollPolicyItem
      key={payrollPolicy.get('id')}
      payrollPolicy={payrollPolicy}
      contractVersions={contractVersions}
      contractVersionsPayrollPolicies={contractVersionsPayrollPolicies}
    />
  ))

  if (payrollPolicies.models.length > 1) {
    return <Grid variant="small">{payrollPolicyItems}</Grid>
  }

  if (payrollPolicies.models.length === 1) {
    return <Box>{payrollPolicyItems}</Box>
  }

  return (
    <GridBoxList centered={payrollPolicies.models.length < 2}>{payrollPolicyItems}</GridBoxList>
  )
}

export default observer(Content)
